import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { doc, serverTimestamp, setDoc } from "firebase/firestore";
import { toast } from "react-toastify";
import { auth, db } from "../firebase";
import "../style/authFlow.css";

const goals = [
  "Get my first QA job",
  "Switch from non-IT to testing",
  "Move from manual to automation",
  "Prepare for interviews",
];

const levels = ["Beginner", "Intermediate", "Working QA"];
const interests = ["Manual Testing", "Automation Testing", "API Testing", "Complete QA Roadmap"];

export default function OnboardingPage() {
  const navigate = useNavigate();
  const [goal, setGoal] = useState("");
  const [level, setLevel] = useState("");
  const [interest, setInterest] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!goal || !level || !interest) {
      toast.error("Please select your goal, level, and interest.");
      return;
    }

    const currentUser = auth.currentUser;

    if (!currentUser) {
      toast.error("Please login again to complete onboarding.");
      navigate("/login");
      return;
    }

    setLoading(true);

    try {
      await setDoc(
        doc(db, "users", currentUser.uid),
        {
          onboardingCompleted: true,
          onboarding: {
            goal,
            level,
            interest,
            completedAt: serverTimestamp(),
          },
          updatedAt: serverTimestamp(),
        },
        { merge: true }
      );

      toast.success("Your learning path is ready.");
      navigate(interest === "Automation Testing" ? "/automation-testing" : "/student");
    } catch (error) {
      toast.error(error.message || "Unable to save onboarding right now.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="onboarding-page">
      <section className="onboarding-card">
        <span className="auth-flow-eyebrow">Personalized setup</span>
        <h1>Tell us your QA learning goal</h1>
        <p>
          This helps QA Coder guide you toward the right topics, practice tasks, and
          course path.
        </p>

        <form onSubmit={handleSubmit}>
          <ChoiceGroup title="Your main goal" options={goals} value={goal} onChange={setGoal} />
          <ChoiceGroup title="Current level" options={levels} value={level} onChange={setLevel} />
          <ChoiceGroup title="Primary interest" options={interests} value={interest} onChange={setInterest} />

          <button className="onboarding-submit" type="submit" disabled={loading}>
            {loading ? "Saving..." : "Finish and Open My Dashboard"}
          </button>
        </form>
      </section>
    </main>
  );
}

function ChoiceGroup({ title, options, value, onChange }) {
  return (
    <fieldset className="choice-group">
      <legend>{title}</legend>
      <div className="choice-grid">
        {options.map((option) => (
          <button
            className={value === option ? "choice-card selected" : "choice-card"}
            type="button"
            key={option}
            onClick={() => onChange(option)}
          >
            {option}
          </button>
        ))}
      </div>
    </fieldset>
  );
}
